import clsx from 'clsx'

import Text from '~/components/Text/Text'
import { PostPreview } from '~/components/PostPreview/PostPreview'

import { MorePostsProps } from './types'
import styles from './MorePosts.module.sass'

const MorePosts: React.FC<MorePostsProps> = ({ posts }) => {
  return (
    <div className={clsx(styles.morePosts, 'site-container site-grid')}>
      <div className='col-span-full lg:col-start-4 lg:col-end-10'>
        <Text variant='subheading' fontSize={[28, 28, 40, 40]} className={styles.headline}>
          More posts you might like
        </Text>

        <div className={styles.list}>
          {posts.map(({ title, authors, excerpt, date, url }) => (
            <div className={styles.post} key={title}>
              <PostPreview
                title={title} authors={authors} excerpt={excerpt} date={date} url={url}
                trackLabel='from-more'
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

export default MorePosts
